import React from 'react'
import { ScrollView } from 'react-native'
import { useCopilot } from 'react-native-copilot'
import { useNoraHomeWalkthroughContext } from './NoraHomeWalkthroughContext'
import { getStepById, getStepIndexById } from './steps'
import {
  NoraHomeWalkthroughPresentation,
  NoraHomeWalkthroughProps,
  NoraHomeWalkthroughStepId,
} from './types'
import { StandaloneStepOverlay } from './StandaloneStepOverlay'

export const NoraHomeWalkthrough = ({ scrollViewRef }: NoraHomeWalkthroughProps = {}) => {
  const context = useNoraHomeWalkthroughContext()

  if (!context) {
    throw new Error('NoraHomeWalkthrough must be rendered inside a NoraHomeWalkthroughProvider.')
  }

  return <NoraHomeWalkthroughContent context={context} scrollViewRef={scrollViewRef} />
}

const NoraHomeWalkthroughContent = ({
  context,
  scrollViewRef,
}: {
  context: NonNullable<ReturnType<typeof useNoraHomeWalkthroughContext>>
  scrollViewRef?: React.RefObject<ScrollView | null>
}) => {
  const { start } = useCopilot()
  const step = getStepById(context.activeStepId)

  if (step.presentation === NoraHomeWalkthroughPresentation.Anchored) {
    return null
  }

  const stepIndex = getStepIndexById(step.id)
  const isFinalStep = step.id === NoraHomeWalkthroughStepId.Capabilities

  const startAnchoredSteps = () => {
    context.showStep(NoraHomeWalkthroughStepId.AskNora)
    requestAnimationFrame(() => {
      void start(undefined, scrollViewRef?.current ?? null)
    })
  }

  return (
    <StandaloneStepOverlay
      step={step}
      stepIndex={stepIndex}
      isFinalStep={isFinalStep}
      onClose={context.close}
      onNext={isFinalStep ? context.complete : startAnchoredSteps}
    />
  )
}
